import { useQuery } from "react-query";
import { inspectedMessagesSchema } from "../Schemas/InspectionMessagesSchemas";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";
import { simpleRequest } from "core/services/api";
import { generatePath } from "react-router-dom";

export const getMessage = (id?: number) =>
  id
    ? simpleRequest(
        generatePath(ENDPOINTS.MSG_INSPECTION, { id }),
        inspectedMessagesSchema
      )
    : undefined;

export function useInspectedMessage(id?: number, fetch = true) {
  return useQuery(["message", id], () => getMessage(id), {
    enabled: !!id,
  });
}
